import Read from './Read.graphql';
import Create from './Create.graphql';
import Update from './Update.graphql';
import Placements from './Placements.graphql';
import PlacementsCount from './PlacementsCount.graphql';
import Delete from './Delete.graphql';
import Source from './Source.graphql';

const PlacementFormReadQuery = Read;
const PlacementFormCreate = Create;
const PlacementFormUpdate = Update;
const PlacementsQuery = Placements;
const PlacementFormPlacementsCountQuery = PlacementsCount;
const PlacementFormDelete = Delete;
const PlacementFormSourceReadQuery = Source;

export {
  PlacementFormDelete,
  PlacementFormReadQuery,
  PlacementsQuery,
  PlacementFormCreate,
  PlacementFormUpdate,
  PlacementFormSourceReadQuery,
  PlacementFormPlacementsCountQuery,
};
